import React from "react";
import Table, { ColumnsType } from "antd/es/table";
import {
  QualityLineProps,
  OrderProps,
  OrderReport,
  RoleProps,
  UserDataProps,
  reportProps,
  ReportMachinistProps,
  ReportMachinistItemProps,
} from "../../interfaces/interfaces";
import { Button, Checkbox } from "antd";
import { EditFilled } from "@ant-design/icons";
import dayjs from "dayjs";

export const OrderTableColumns: ColumnsType<OrderProps> = [
  {
    title: "ID",
    dataIndex: "OrderId",
    key: "OrderId",
  },
  // {
  //   title: "Edit",
  //   dataIndex: "X",
  //   render: () => <Button icon={<EditFilled />}></Button>,
  // },
  {
    title: "Rig Number",
    dataIndex: "RigNumberDetail",
    render: (_, { RigNumberDetail }) => (
      <>{RigNumberDetail ? RigNumberDetail.Name : ""}</>
    ),
  },
  {
    title: "Connection",
    dataIndex: "Connection",
  },
  {
    title: "Pin Recuts",
    dataIndex: "PinRecuts",
  },
  {
    title: "Box Recuts",
    dataIndex: "BoxRecuts",
  },
  {
    title: "Pin Reface",
    dataIndex: "PinReface",
  },
  {
    title: "Box Reface",
    dataIndex: "BoxReface",
  },
  {
    title: "Quality Checks",
    dataIndex: "QualityLines",
    render(value, record, index) {
      return <>{record.QualityLines ? record.QualityLines.length : 0}</>;
    },
  },
];

export const QualityLinesTableColumns: ColumnsType<QualityLineProps> = [
  {
    title: "Edit",
    dataIndex: "X",
    render: () => <Button icon={<EditFilled />}></Button>,
  },
  {
    title: "Machinist",
    dataIndex: "userDetail",
    render: (_, { userDetail }) => <>{userDetail ? userDetail.Name : ""}</>,
  },
  {
    title: "Date",
    dataIndex: "Date",
    render: (params) => <>{params ? dayjs(params).format("MM/DD/YYYY") : ""}</>,
  },
  {
    title: "Pin/Box",
    dataIndex: "PinBox",
  },
  // {
  //   title: "Gauge",
  //   dataIndex: "Gauge",
  // },
  // {
  //   title: "Length",
  //   dataIndex: "Length",
  // },
  // {
  //   title: "Nose Diameter",
  //   dataIndex: "NoseDiameter",
  // },
  // {
  //   title: "Cylinder Diameter",
  //   dataIndex: "CylinderDiameter",
  // },
  // {
  //   title: "Lead",
  //   dataIndex: "Lead",
  // },
  // {
  //   title: "Taper",
  //   dataIndex: "Taper",
  // },
  // {
  //   title: "Bevel Diameter",
  //   dataIndex: "BevelDiameter",
  // },
];

export const RoleTableColumns: ColumnsType<RoleProps> = [
  {
    title: "Name",
    dataIndex: "Name",
  },
  {
    title: "Is Administrative",
    dataIndex: "IsAdministrative",
    align: "center",
    render: (params) => <Checkbox checked={params} />,
  },
  {
    title: "Can Edit Model",
    dataIndex: "CanEditModel",

    render: (params) => <Checkbox checked={params} />,
  },
];

export const UserTableColumns: ColumnsType<UserDataProps> = [
  {
    title: "Name",
    dataIndex: "Name",
  },
  {
    title: "Username",
    dataIndex: "UserName",
  },
  {
    title: "Action",
    key: "action",
    render: (_, record) => (
      <Button
        danger
        onClick={() => {
          /* remove user logic here */
        }}
      >
        Remove
      </Button>
    ),
  },
];

export const ReportTableColumns: ColumnsType<reportProps> = [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Data Type",
    dataIndex: "dataType",
  },
];

// **QualityLines Table (Nested Inside User Table)**
const QualityLinesTable = ({
  qualityLines,
}: {
  qualityLines: QualityLineProps[];
}) => {
  const columns: ColumnsType<QualityLineProps> = [
    {
      title: "Order",
      dataIndex: "Order",
    },
    {
      title: "Employee",
      dataIndex: "Employee",
    },
    {
      title: "Date",
      dataIndex: "Date",
      // render: (date) => (date ? date.format("YYYY-MM-DD") : "N/A"),
    },
    {
      title: "Pin/Box",
      dataIndex: "PinBox",
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={qualityLines}
      pagination={false}
      rowKey="key"
    />
  );
};

// **User Table (Nested Inside Date Table)**
const UserTable = ({ users }: { users: ReportMachinistProps["Data"] }) => {
  const columns: ColumnsType<ReportMachinistProps["Data"]> = [
    {
      title: "Name",
      dataIndex: "User",
      render: (user: UserDataProps) => <>{user?.Name}</>,
    },
    {
      title: "Total by Machinist",
      dataIndex: "QualityLines",
      render: (qualityLines) => <>{qualityLines ? qualityLines.length : 0}</>,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={users as any}
      pagination={false}
      // rowKey={(record) => record.User.OID}
    />
  );
};

// **Main Table (Groups Data by Date)**
export const MachinistTableColumns: ColumnsType<ReportMachinistProps> = [
  {
    title: "Date",
    dataIndex: "Date",
    fixed: "left",
  },
  {
    title: "Machinists",
    dataIndex: "Data",
    render: (_, { Data }) => <UserTable users={Data} />,
  },
  {
    title: "Total By Date",
    render: (_, { Data: innerData }) => {
      let total = 0;
      innerData.forEach((item) => {
        total += item.QualityLines.length;
      });
      return <>{total}</>;
    },
  },
];
